import { apiRequest, jsonBody } from '../../lib/api-client';
import type { CurrentUser } from '../../lib/api-types';

interface AuthResponse {
  readonly user: CurrentUser;
}

export interface LoginInput {
  readonly email: string;
  readonly password: string;
}

export interface RegisterInput extends LoginInput {
  readonly name: string;
}

export async function login(input: LoginInput): Promise<CurrentUser> {
  return (
    await apiRequest<AuthResponse>(
      '/api/users/login',
      {
        body: jsonBody(input),
        method: 'POST',
      },
      false,
    )
  ).user;
}

export async function register(input: RegisterInput): Promise<CurrentUser> {
  return (
    await apiRequest<AuthResponse>(
      '/api/users/register',
      {
        body: jsonBody(input),
        method: 'POST',
      },
      false,
    )
  ).user;
}

export async function loginWithGoogle(idToken: string): Promise<CurrentUser> {
  return (
    await apiRequest<AuthResponse>(
      '/api/users/google-auth',
      {
        body: jsonBody({ idToken }),
        method: 'POST',
      },
      false,
    )
  ).user;
}

export async function fetchPublicConfig(): Promise<{
  readonly googleClientId: string;
  readonly vapidPublicKey: string;
}> {
  return apiRequest('/api/config', {}, false);
}
